import { baseURL } from '@src/configuration/constants';

import { MediaType } from './types';

export const UPLOAD_VIDEO_PATH = `${baseURL}/media/v1/tus/upload/video`;
export const UPLOAD_IMAGE_PATH = `${baseURL}/media/v1/tus/upload/image`;

export const getFileExtension = (_uri: string): string => {
  const uriFormatMatch = /\.([a-zA-Z]+)$/.exec(_uri); // native format ({ uri: file:///path-to-file.jpg, ... })
  const base64FormatMatch = /\S+:\w+\/(\w+)\S+/.exec(_uri); // base64 format ('data:image/jpeg;base64...')
  if (uriFormatMatch) {
    return uriFormatMatch[1];
  } else if (base64FormatMatch) {
    const type = base64FormatMatch[1];
    if (type === 'jpeg') {
      return 'jpg';
    }
    return type;
  }

  return '';
};

export const getMimeType = (extension: string): string => {
  switch (extension) {
    case 'jpg':
      return 'image/jpeg';
    default:
      return `image/${extension}`;
  }
};

export const getUploadEndpoint = (mediaType: MediaType): string => {
  switch (mediaType) {
    case 'image':
      return UPLOAD_IMAGE_PATH;
    case 'video':
      return UPLOAD_VIDEO_PATH;
    default:
      throw new Error('Invalid `mediaType` for MediaPicker');
  }
};

export async function urlToFile(
  url: string,
  filename: string,
  mimeType: string
) {
  const res = await fetch(url);
  const buf = await res.arrayBuffer();
  // eslint-disable-next-line no-undef
  return new File([buf], filename, { type: mimeType });
}
